import { AnimationControls, motion } from 'framer-motion';
import { LightningIcon } from './LightningIcon';

import cx from 'classnames';

import lightningStyles from './LightningButton.module.scss';

import { lightningRotationVariants } from './LightningButton';
import TransparentLink from './TransparentLink';

interface FakeButtonProps {
  isHoverOnCard: boolean;
  animationControls: AnimationControls;
  isLightningButton: boolean;
  titleOnButton?: string;
}

const FakeButton = (props: FakeButtonProps) => {
  const { animationControls, isHoverOnCard, isLightningButton, titleOnButton } =
    props;

  if (isLightningButton) {
    return (
      <div
        className={cx(lightningStyles.lightningButton, {
          [lightningStyles.buttonSmall]: true,
          [lightningStyles.cardIsOnHover]: isHoverOnCard,
        })}
      >
        <div className={lightningStyles.backgroundGradient} />
        <span className={lightningStyles.buttonTextLarge}>
          <motion.div
            animate={animationControls}
            variants={lightningRotationVariants}
            initial="initial"
            className={lightningStyles.lightningWrapper}
          >
            <LightningIcon className={lightningStyles.lightningIcon} />
          </motion.div>
          {titleOnButton ?? 'Velja'}
        </span>
      </div>
    );
  }

  return <TransparentLink text={titleOnButton ?? 'Skoða'} style="small" />;
};

export default FakeButton;
